import { useSelector } from 'react-redux';
import {
  selectAccessToken,
} from './accessTokenSlice';

export const useAccessToken = () => {
  const { body, authId } = useSelector(selectAccessToken);

  return {
    authId,
    body,
  };
};
